'use client';

import { Fragment } from 'react';
import Cartaz from '@/components/atoms/Cartaz';
import * as S from './styles';
import Heading from '@/components/atoms/Heading';
import Text from '@/components/atoms/Text';
import { useTheme } from 'styled-components';
import IconButton from '@/components/atoms/IconButton';
import { IconeOlho } from '@/components/atoms/Icones/IconeOlho';
import { IconeBookmark } from '@/components/atoms/Icones/IconeBookmark';
import { IconeCoracao } from '@/components/atoms/Icones/IconeCoracao';
import { IconeMascaras } from '@/components/atoms/Icones/IconeMascaras';
import NotaFicha from '@/components/molecules/NotaFicha';
import BlocoInformacao from '@/components/atoms/BlocoInformacao';
import Plataforma from '@/components/atoms/Plataforma';
import ListagemResenhasComentario from '@/components/organisms/ListagemResenhasComentario';
import Avatar from '@/components/atoms/Avatar';
import { Separator } from '@/components/atoms/Separator';
import Button from '@/components/atoms/Button';
import Imagem from '@/components/atoms/Imagem';
import AvaliarChippu from '@/components/molecules/AvaliarChippu';
import { useSession } from 'next-auth/react';
import obterIniciaisNomeUsuario from '@/utils/obterIniciaisNomeUsuario';
import BreadcrumbPagina from '@/components/molecules/BreadcrumbPagina';
import ListagemTitulos from '@/components/organisms/ListagemTitulos';
import { FichaPaginaProps } from '../..';
import ListagemElenco from '@/components/organisms/ListagemElenco';
import { registrarEvento } from '@/services/googleAnalytics';

export default function FichaPaginaMobile(props: FichaPaginaProps) {
  const {
    ficha,
    loadingEnviarResenha,
    embededUrl,
    favoritar,
    loadingFavoritar,
    abrirModalPlaylists,
    favoritado,
    jaVi,
    loadingJaVi,
    emAltaStreaming,
    carregandoEmAltaStreaming,
    avaliacao,
    setAvaliacao,
    setMostrandoModalPlataformas,
    irParaAvaliacao,
    assistido,
    registrarCliquePlataforma,
  } = props;

  const { data } = useSession();
  const theme = useTheme();

  return (
    <Fragment>
      <BreadcrumbPagina $nomePaginaAtual={ficha?.titulo || ''} />
      <S.BackgroundWrapper>
        <S.Grandiente />
        <S.BlurredBackground>
          {ficha?.posterArquivo?.urlx2 != null &&
          ficha?.posterArquivo?.urlx2 !== '' ? (
            <Imagem
              imagemUrl={ficha?.posterArquivo?.urlx2}
              descricaoImagem={`fundo da página com o cartaz do filme ${ficha?.titulo}`}
              priority
              style={{
                objectFit: 'cover',
                width: '100%',
                height: '100%',
              }}
            />
          ) : null}
        </S.BlurredBackground>
        <Cartaz
          $tamanho={'medio'}
          src={ficha?.posterArquivo?.urlx3 || ''}
          alt={`cartaz do filme ${ficha?.titulo}`}
          style={{
            zIndex: 1,
            position: 'absolute',
            top: theme.spacing[5],
          }}
        />
      </S.BackgroundWrapper>
      <S.Container>
        <S.ContainerTop>
          <S.Row
            style={{
              gap: theme.spacing[6],
              flexDirection: 'column',
              width: '100%',
            }}
          >
            <S.ContainerInfos>
              <Heading
                $priority={1}
                $size={5}
                $color="neutral"
                $weight="bold"
                $align="left"
                $highContrast={true}
                $text={ficha?.titulo || ''}
              />
              {ficha?.generos != null && ficha?.generos.length > 0 ? (
                <S.Row>
                  {ficha?.generos?.map((genero, index) => (
                    <Fragment key={genero.generoID}>
                      {genero?.genero.nome}
                      {index < ficha?.generos?.length - 1 && ', '}
                    </Fragment>
                  ))}
                </S.Row>
              ) : null}
              {ficha?.diretorPessoa?.nome ? (
                <S.Row style={{ gap: theme.spacing[2] }}>
                  <Text
                    $size={3}
                    $color="neutral"
                    $weight="bold"
                    $align="center"
                    $highContrast={true}
                    $text="Direção:"
                  />
                  {ficha?.diretorPessoa?.nome}
                </S.Row>
              ) : null}
              {ficha?.duracao != null ? (
                <S.Row style={{ gap: theme.spacing[2] }}>
                  <Text
                    $size={3}
                    $color="neutral"
                    $weight="bold"
                    $align="center"
                    $highContrast={true}
                    $text="Duração:"
                  />
                  {ficha?.duracao}min
                </S.Row>
              ) : null}
              <S.Row
                style={{
                  gap: theme.spacing[7],
                  alignItems: 'flex-start',
                  justifyContent: 'left',
                  width: '100%',
                }}
              >
                <IconButton
                  $size={3}
                  $state="default"
                  $variant="soft"
                  $color="neutral"
                  $highContrast
                  $loading={false}
                  $Icon={IconeBookmark}
                  $focusRing
                  $onClick={abrirModalPlaylists}
                  $shape="round"
                  $textoInferior="Salvar"
                />

                <IconButton
                  $size={3}
                  $state="default"
                  $variant="soft"
                  $color="neutral"
                  $iconProps={{
                    $fillColor: favoritado ? theme.colors.accent.accent[9] : '',
                  }}
                  $highContrast
                  $loading={loadingFavoritar}
                  $Icon={IconeCoracao}
                  $focusRing
                  $onClick={favoritar}
                  $shape="round"
                  $textoInferior="Curtir"
                />
                <IconButton
                  $size={3}
                  $state="default"
                  $variant="soft"
                  $color="neutral"
                  $highContrast
                  $loading={false}
                  $Icon={IconeMascaras}
                  $focusRing
                  $onClick={irParaAvaliacao}
                  $shape="round"
                  $textoInferior="Escrever sua crítica"
                />
                <IconButton
                  $size={3}
                  $state="default"
                  $variant="soft"
                  $color="neutral"
                  $highContrast={true}
                  $loading={loadingJaVi}
                  $Icon={IconeOlho}
                  $iconProps={
                    assistido
                      ? {
                          color: theme.colors.accent.accent[9],
                        }
                      : undefined
                  }
                  $focusRing
                  $onClick={jaVi}
                  $shape="round"
                  $textoInferior="Marcar como visto"
                />
              </S.Row>
            </S.ContainerInfos>
          </S.Row>

          {ficha?.plataformas != null && ficha.plataformas.length > 0 ? (
            <BlocoInformacao
              id={'containerPlataformas'}
              $titulo="Como assistir"
              $childrenContainerstyle={{
                display: 'grid',
                gridTemplateRows:
                  ficha.plataformas.length < 4
                    ? 'repeat(1, auto)'
                    : 'repeat(2, auto)',
                overflow: 'scroll',
                gridTemplateColumns:
                  // @ts-expect-error Falta tipos do next
                  document.getElementById('containerPlataformas')?.offsetWidth /
                    84 >=
                  5
                    ? 'repeat(4, 1fr)'
                    : 'repeat(3, 1fr)',
                rowGap: theme.spacing[4],
              }}
            >
              {ficha?.plataformas?.map((plataforma) => (
                <Plataforma
                  $eventoAnalytics={() => registrarCliquePlataforma(plataforma)}
                  key={plataforma?.plataformaStreamingID}
                  $image={plataforma?.plataformaStreaming?.logoArquivo?.urlx1}
                  $nome={plataforma.plataformaStreaming.nome}
                  $link={plataforma.link}
                />
              ))}
            </BlocoInformacao>
          ) : null}
          <S.Row
            style={{
              alignSelf: 'center',
              gap: theme.spacing[5],
              flexWrap: 'wrap',
              justifyContent: 'space-between',
              width: '100%',
            }}
          >
            <NotaFicha
              style={{ width: '45%' }}
              $tipo="comunidade"
              $nota={
                ficha?.notaComunidade
                  ? Number(ficha.notaComunidade.toFixed(1))
                  : 0
              }
            />
            <NotaFicha
              style={{ width: '45%' }}
              $tipo="chippu"
              $nota={ficha?.nota ? Number(ficha.nota.toFixed(1)) : 0}
            />
          </S.Row>
        </S.ContainerTop>
        <S.Row
          style={{
            gap: theme.spacing[6],
            flexDirection: 'column',
            width: '100%',
          }}
        >
          <BlocoInformacao
            $titulo="Sinopse"
            $childrenContainerstyle={{ overflowX: 'hidden' }}
          >
            {ficha?.sinopse}
          </BlocoInformacao>
        </S.Row>
        <S.Row
          style={{
            gap: theme.spacing[6],
            width: '100%',
            flex: 1,
            flexDirection: 'column',
          }}
        >
          {ficha?.equipe != null && ficha?.equipe.length > 0 ? (
            <BlocoInformacao
              $titulo="Elenco e equipe"
              $style={{
                flex: 1,
                height: 344,
                paddingRight: 0,
              }}
            >
              <ListagemElenco $elenco={ficha?.equipe} />
            </BlocoInformacao>
          ) : null}

          {embededUrl !== '' ? (
            <BlocoInformacao
              $titulo="Trailer"
              $style={{
                height: 344,
              }}
            >
              <iframe
                src={embededUrl}
                allowFullScreen
                style={{
                  borderRadius: theme.radius[3],
                  height: 240,
                }}
              />
            </BlocoInformacao>
          ) : null}
        </S.Row>
        <BlocoInformacao
          $titulo="Críticas da comunidade"
          $style={{
            gap: ficha?.resenhas == null ? 0 : theme.spacing[7],
            paddingLeft: 0,
            paddingRight: 0,
            paddingBottom: 0,
          }}
          headerStyle={{ marginLeft: theme.spacing[5] }}
          $childrenContainerstyle={{ maxHeight: 870 }}
        >
          <Fragment>
            <ListagemResenhasComentario
              $nomeFicha={ficha?.titulo || ''}
              contentContainerStyle={{ padding: theme.spacing[5] }}
              $dados={ficha?.resenhas || []}
            />
            <BlocoInformacao
              $style={{
                backgroundColor: theme.colors.neutral.neutral[3],
                marginTop: theme.spacing[5],
                paddingTop: 20,
                paddingBottom: theme.spacing[4],
                paddingRight: theme.spacing[4],
                paddingLeft: theme.spacing[4],
              }}
              $titulo="Fazer minha resenha"
            >
              {data?.user != null ? (
                <S.Row>
                  <Avatar
                    $size={3}
                    $image={data?.user?.image || ''}
                    $initials={
                      !data?.user?.image
                        ? obterIniciaisNomeUsuario(data?.user.name ?? '')
                        : undefined
                    }
                    $preencherFundo={!data?.user?.image}
                    $shape="rounded"
                    $variant="solid"
                    $color="accent"
                    $initialsColor={theme.tokens.colors.black_contrast}
                    $style={{ marginRight: theme.spacing[3] }}
                  />
                  <Text
                    $size={4}
                    $color="neutral"
                    $weight="semibold"
                    $align="center"
                    $highContrast
                    $text={data?.user?.name}
                  />
                </S.Row>
              ) : null}

              <S.ContainerInput>
                <AvaliarChippu
                  onClick={(valor) => setAvaliacao(valor)}
                  $avaliacao={avaliacao}
                />
                <S.TextInput
                  name="comentario"
                  placeholder="Escreva sua avaliação"
                  id="campoComentario"
                  onClick={() => {
                    registrarEvento('clique_input_resenha', {
                      ficha: ficha?.titulo,
                      fichaID: ficha?.tituloID,
                    });
                  }}
                />
                <Separator $block={false} $orientation="horizontal" />
                <S.Row
                  style={{
                    width: '100%',
                    justifyContent: 'flex-end',
                    gap: theme.spacing[2],
                  }}
                >
                  <div>
                    <Button
                      $text="Enviar"
                      $disable={avaliacao === 0}
                      $color="accent"
                      $highContrast={false}
                      $focusRing
                      $loading={loadingEnviarResenha}
                      $variant="solid"
                      $size={1}
                      $onClick={() => setMostrandoModalPlataformas(true)}
                    />
                  </div>
                </S.Row>
              </S.ContainerInput>
            </BlocoInformacao>
          </Fragment>
        </BlocoInformacao>
        {emAltaStreaming?.length != null && emAltaStreaming?.length > 0 ? (
          <BlocoInformacao
            $titulo="Outras recomendações"
            $style={{ flex: 1, paddingRight: 0 }}
          >
            <ListagemTitulos
              $conteudos={emAltaStreaming}
              $carregandoConteudos={carregandoEmAltaStreaming}
              $paddingLeft={0}
            />
          </BlocoInformacao>
        ) : null}
      </S.Container>
    </Fragment>
  );
}
